import React, { useState } from 'react'

type TabOption = {
    key: string
    label: string
    content: React.ReactNode
}

interface ProjectSummaryTabsProps {
    tabs: TabOption[]
    defaultActiveKey?: string
}

export const ProjectSummaryTabs: React.FC<ProjectSummaryTabsProps> = ({
    tabs,
    defaultActiveKey,
}) => {
    const [activeKey, setActiveKey] = useState<string>(
        defaultActiveKey || tabs[0].key
    )

    return (
        <>
            {/* Metronic Button Tabs */}
            <div className='d-flex flex-column'>
                <div className='stepper stepper-links d-flex flex-column between'>
                    <div className='stepper-nav flex-row mb-10'>
                        {tabs.map((tab) => (
                        <div
                            key={tab.key}
                            className={`stepper-item cursor-pointer ${activeKey === tab.key ? 'current' : ''}`}
                            onClick={() => setActiveKey(tab.key)}
                        >
                            <h3 className='stepper-title'>{tab.label}</h3>
                        </div>
                        ))}
                    </div>

                    {tabs.map((tab) => (
                        <div
                        key={`${tab.key}-content`}
                        className={activeKey === tab.key ? 'current' : ''}
                        style={{ display: activeKey === tab.key ? 'flex' : 'none' }}
                        >
                            <div className='d-flex flex-center w-100'>
                                {tab.content}
                            </div>
                        </div>
                    ))}
                    </div>               
            </div>
        </>
    )
}